import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import ShopLayout from "../Layout";
import GetShopChatsList from "../../Chat/index";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import BreadCrumb from "../../Layouts/Breadcrumb";

const ShopChatsList = (): ReactElement => {
  const route = useParams();
  return (
    <React.Fragment>
      <BreadCrumb
        shopId={(route as any)?.shopId}
        title="Chats"
        subTitle="Chats"
        extra={<></>}
      />
      <GetShopChatsList inShop={true} getShopId={(route as any)?.shopId} />
    </React.Fragment>
  );
};

ShopChatsList.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default ShopChatsList;
